// Client V2 common imports
const { useExperiment } = require('client-v2/common/containers/rollouts')
const useMatchMedia = require('client-v2/common/hooks/match-media')

function useHasSeriesFeed() {
  let hasSeriesFeed = useExperiment('*web_rec_series_feed') === 'enabled'
  const isWindowTooNarrow = useMatchMedia('(max-width: 1024px)')
  const isWindowTooShort = useMatchMedia('(max-height: 768px)')
  if (isWindowTooNarrow || isWindowTooShort) {
    hasSeriesFeed = false
  }
  return hasSeriesFeed
}

module.exports = {
  useHasSeriesFeed
}
